import { Component } from '@angular/core';
import { Constants } from 'src/app/core/constants';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent {
  public readonly isMobile = Constants.IsMobile;
}
